import ajax from '@/libs/api.request'

export default {
  getList:param=>{
    return ajax.get('edu/web/schedule/list',param);
  },
  findOne:param=>{
    return ajax.post('edu/web/schedule/findOne',param);
  },
  saveOne:param=>{
    return ajax.post('edu/web/schedule/saveOne',param);
  },
  saveRepeat:param=>{
    return ajax.post('edu/web/schedule/saveRepeat',param);
  },
  deleteOne:param=>{
    return ajax.post('edu/web/schedule/deleteOne',param);
  },
  deleteRepeat:param=>{
    return ajax.post('edu/web/schedule/deleteRepeat',param);
  },
  cancelOne:param=>{
    return ajax.post('edu/web/schedule/cancelOne',param);
  },
  getStudentScheduleList:param=>{
    return ajax.get('edu/web/schedule/getStudentScheduleList',param);
  },
}
